import { render } from "./lydialog.vue?vue&type=template&id=72827b90"
import script from "./lydialog.vue?vue&type=script&lang=js"
export * from "./lydialog.vue?vue&type=script&lang=js"

import "./lydialog.vue?vue&type=style&index=0&id=72827b90&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__